import UnlocksOverlay from "@pathwright/ui/src/components/overlay/UnlocksOverlay"
import Text from "@pathwright/ui/src/components/ui/Text"
import PropTypes from "prop-types"
import styled from "styled-components"
import * as PathUI from "../ui/PathUI"
import LearnPathResource from "./LearnPathResource"
import LearnPathScheduleLabel from "./LearnPathScheduleLabel"
import LearnPathStep from "./LearnPathStep"

const StyledContainer = styled.div`
  margin-top: 10px;
`

const LearnPathLesson = ({ pathItem }) => {
  return (
    <PathUI.PathLessonContainer>
      <PathUI.PathLessonHeader>
        <Text.H4 inverted>{pathItem.name}</Text.H4>
        <Text.Meta inverted>{pathItem.description}</Text.Meta>
        <StyledContainer>
          <LearnPathScheduleLabel pathItem={pathItem} inverted />
        </StyledContainer>
      </PathUI.PathLessonHeader>
      <PathUI.PathLessonGrid>
        {pathItem.items.map((childPathItem) => (
          <li key={childPathItem.id}>
            {childPathItem.type === "resource" ? (
              <LearnPathResource
                pathItem={childPathItem}
                parentPathItem={pathItem}
                layout="grid"
              />
            ) : childPathItem.type === "step" ? (
              <LearnPathStep
                pathItem={childPathItem}
                parentPathItem={pathItem}
              />
            ) : null}
          </li>
        ))}
      </PathUI.PathLessonGrid>
      <UnlocksOverlay starts={pathItem.starts} overlay inverted />
    </PathUI.PathLessonContainer>
  )
}

LearnPathLesson.displayName = "LearnPathLesson"

LearnPathLesson.propTypes = {
  pathItem: PropTypes.object.isRequired
}

export default LearnPathLesson
